'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _document_link = require('./document_link.js');

var _document_link2 = _interopRequireDefault(_document_link);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ramda = require('ramda');

var _functional_utility = require('../../../packages/common-utilities/src/functional_utility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapIndexed = (0, _ramda.addIndex)(_ramda.map);

var FundDocumentList = function (_React$PureComponent) {
  _inherits(FundDocumentList, _React$PureComponent);

  function FundDocumentList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, FundDocumentList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FundDocumentList.__proto__ || Object.getPrototypeOf(FundDocumentList)).call.apply(_ref, [this].concat(args))), _this), _this.reorderDocuments = function (documents) {
      var order = ["Commentary", "Fund Story", "Fact Sheet (US EMEA)"];
      var reorderedDocuments = [];

      order.forEach(function (type) {
        documents = documents.filter(function (doc) {
          if (!(doc.documentType == null) && doc.documentType.includes(type)) {
            reorderedDocuments.unshift(doc);
            return false;
          }
          return true;
        });
      });

      return [].concat(reorderedDocuments, _toConsumableArray(documents));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(FundDocumentList, [{
    key: 'renderDocumentList',
    value: function renderDocumentList(documentList, isDocumentTabCard) {
      var _this2 = this;

      if ((0, _functional_utility.isNilOrEmpty)(documentList)) {
        return null;
      }
      var additionalMargins = isDocumentTabCard ? " margin-bottom-10 margin-horizontal-10" : "";
      return _react2.default.createElement(
        'ul',
        { className: 'list-unstyled' + additionalMargins, 'data-testid': 'doc-list-' + this.props.headerTitleId, id: 'doc-list-' + this.props.headerTitleId },
        mapIndexed(function (fundDocument, index) {
          return _react2.default.createElement(
            'li',
            { key: index },
            _react2.default.createElement(_document_link2.default, { fundDocument: fundDocument,
              userLoggedIn: _this2.props.userLoggedIn,
              role: _this2.props.role,
              breakpoint: _this2.props.breakpoint,
              visibleDataPoints: _this2.props.visibleDataPoints,
              basePath: _this2.props.basePath,
              window: _this2.props.window,
              cmsHost: _this2.props.cmsHost,
              headerTitleId: _this2.props.headerTitleId,
              isAEM: _this2.props.isAEM,
              leavingSiteOverlay: _this2.props.leavingSiteOverlay,
              showDownloadIcon: _this2.props.showDownloadIcon,
              textColorClass: _this2.props.textColorClass,
              defaultStyle: _this2.props.defaultStyle,
              isLastRow: isDocumentTabCard ? false : index === documentList.length - 1, intl: _this2.props.intl,
              country: _this2.props.country,
              language: _this2.props.language
            })
          );
        }, documentList)
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var userLoggedIn = this.props.userLoggedIn;
      var documents = this.props.documents;

      if ((0, _functional_utility.isNilOrEmpty)(documents)) {
        return null;
      }

      if (this.props.isAEM && !userLoggedIn) {
        documents = (0, _ramda.filter)(function (document) {
          return !document.isProtected;
        }, documents);
      }

      documents = this.props.isOrderedList ? this.reorderDocuments(documents) : documents;
      var dataArr = (0, _ramda.splitEvery)(Math.ceil(documents.length / this.props.noOfColumns), documents);
      var widthPercent = Math.round(100 / dataArr.length);
      var additionalClasses = this.props.noOfColumns > 1 ? " max-width-percent-50 padding-right-20" : "";
      var docData = [];
      for (var i = 0; i < dataArr.length; i++) {
        docData.push(_react2.default.createElement(
          'div',
          { className: 'display-inline-block width-percent-' + widthPercent + ' text-top' + additionalClasses },
          this.renderDocumentList(dataArr[i], this.props.isDocumentTabCard)
        ));
      }
      return _react2.default.createElement(
        'div',
        { className: 'category' },
        docData
      );
    }
  }]);

  return FundDocumentList;
}(_react2.default.PureComponent);

exports.default = FundDocumentList;